var render, staticRenderFns
import script from "./PieCustom.vue?vue&type=script&lang=js&"
export * from "./PieCustom.vue?vue&type=script&lang=js&"
import style0 from "./PieCustom.vue?vue&type=style&index=0&id=7b93f2d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b93f2d6",
  null
  
)

export default component.exports